export default function PHP_setlocale() {
  return (
    <div>
      <h1>PHP_setlocale</h1>
    </div>
  );
}
